import React from "react";
import { filterTasksByTaskType } from "../modules/Task/components/Utils";
// import PropTypes from "prop-types";

const TablePageReport = ({
  totalRecords,
  // filteredRecords,
  first,
  rows,
  className = "report-table-page-report",
  emptyText = "Keine Ergebnisse",
  itemName = "Zeile",
  itemNamePlural = "Zeilen",
}) => {
  // const firstRow = Math.min(first + 1, filteredRecords);
  // const lastRow = Math.min(first + rows, filteredRecords);
  // let text = `Zeige Zeilen ${firstRow} bis ${lastRow} von ${filteredRecords} Zeilen`;
  // if (totalRecords !== undefined && filteredRecords !== undefined && totalRecords !== filteredRecords) {
  //   text += `\n(gefiltert von insgesamt ${totalRecords} Zeilen)`;
  // }
  const firstRow = totalRecords === 0 ? 0 : first + 1;
  const lastRow =
    totalRecords === undefined
      ? first + rows
      : Math.min(first + rows, totalRecords);
  let text = `Zeige ${itemName} ${firstRow} bis ${lastRow}`;
  if (totalRecords !== undefined && !isNaN(totalRecords)) {
    text += ` von insgesamt ${totalRecords} ${totalRecords > 1 ? itemNamePlural : itemName}`;
    if (`${totalRecords}` === "0") {
      text = emptyText;
    } else if (`${totalRecords}` === "1") {
      text = `Zeige ${itemName} ${firstRow}`;
    }
  } else {
    text = "";
  }
  return <div className={className}>{text}</div>;
};

export default TablePageReport;


export const adjustPageIndex = (data, connectionTaskType, rows, first, setFirst, noConnectionTaskTypeFiltering) => {
  const items = noConnectionTaskTypeFiltering
    ? data
    : data.filter((item) => filterTasksByTaskType(item, connectionTaskType));
  const maxFirst = Math.max(0, Math.ceil(items.length / rows) - 1) * rows;
  console.log(`ADConnectionTaskList adjustPageIndex() items.length=${items.length} first=${first} rows=${rows} maxFirst=${maxFirst}`);
  if (first !== null && first > maxFirst && items.length > 0) {
    console.log(`ADConnectionTaskList adjustPageIndex() resetting first to ${maxFirst}`);
    setFirst(maxFirst);
  }
};
